module.exports = __webpack_public_path__ + "img/picture.f254d347.png";